(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yh-article-toc"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__articleTocBound) return;
  window.__articleTocBound = true;

  const COMPACT_QUERY = window.matchMedia('(max-width: 1024px)');
  const instances = new Set();
  let scrollTicking = false;

  function isCompact() {
    return COMPACT_QUERY.matches;
  }

  function stickyOffset() {
    let bottom = 0;
    const nodes = document.querySelectorAll(
      '#shopify-section-header, .shopify-section-header-sticky, .section-header-navigation, #shopify-section-announcement-bar'
    );

    nodes.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.bottom > bottom && rect.bottom > 0 && rect.top < 180) {
        bottom = rect.bottom;
      }
    });

    return (bottom > 0 ? bottom : 0) + 16;
  }

  function assignId(heading, index, sectionId, used) {
    let id = heading.getAttribute('id');

    if (!id) {
      id = 'toc-' + sectionId + '-' + index;
    }

    const base = id;
    let n = 2;

    while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
      id = base + '-' + n;
      n += 1;
    }

    used.add(id);
    heading.id = id;
    return id;
  }

  function setActive(links, current) {
    links.forEach((link) => {
      const on = link === current;
      link.classList.toggle('active', on);

      if (on) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function scrollToHeading(heading) {
    const offset = stickyOffset();
    heading.style.scrollMarginTop = offset + 'px';
    const top = heading.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  }

  function openDrawer(instance) {
    instance.panel.classList.add('is-open');
    instance.trigger.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer(instance) {
    instance.panel.classList.remove('is-open');
    instance.trigger.setAttribute('aria-expanded', 'false');
  }

  function placeDesktop(instance) {
    if (isCompact()) {
      instance.root.style.top = '';
      instance.root.style.maxHeight = '';
      instance.panel.style.top = '';
      instance.panel.style.maxHeight = '';
      return;
    }

    const offset = stickyOffset();
    instance.root.style.top = offset + 'px';
    instance.root.style.maxHeight = 'calc(100vh - ' + (offset + 16) + 'px)';
    instance.panel.style.top = '';
    instance.panel.style.maxHeight = '';
    instance.headings.forEach((heading) => {
      heading.style.scrollMarginTop = offset + 'px';
    });
  }

  function updateActive(instance) {
    const line = stickyOffset() + 8;
    let current = null;

    instance.headings.forEach((heading, index) => {
      if (heading.getBoundingClientRect().top <= line) {
        current = instance.links[index];
      }
    });

    setActive(instance.links, current);
  }

  function prune() {
    instances.forEach((instance) => {
      if (!instance.root.isConnected) instances.delete(instance);
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.tocReady === 'true') return;

    const sectionId = root.dataset.sectionId;
    const articleSection = document.getElementById('ArticleSection-' + sectionId);
    const article = articleSection ? articleSection.querySelector('.article-content') : null;
    const list = root.querySelector('[data-toc-list]');
    const panel = root.querySelector('.article-toc');
    const trigger = root.querySelector('.article-toc-mobile-trigger');
    const closeBtn = root.querySelector('.article-toc-close');

    if (!article || !list || !panel || !trigger) return;

    const headings = Array.from(article.querySelectorAll('h2')).filter((heading) => {
      return heading.textContent.replace(/\s+/g, ' ').trim().length > 0 && !heading.closest('[data-article-toc]');
    });

    if (headings.length === 0) {
      root.hidden = true;
      if (articleSection) articleSection.classList.remove('article-toc-active');
      root.dataset.tocReady = 'true';
      return;
    }

    const used = new Set();
    const instance = {
      root: root,
      panel: panel,
      trigger: trigger,
      headings: headings,
      links: []
    };

    headings.forEach((heading, index) => {
      const id = assignId(heading, index, sectionId, used);
      const text = heading.textContent.replace(/\s+/g, ' ').trim();
      const li = document.createElement('li');
      const link = document.createElement('a');

      link.href = '#' + id;
      link.className = 'toc-h2';
      link.textContent = text;
      li.appendChild(link);
      list.appendChild(li);
      instance.links.push(link);

      link.addEventListener('click', function (event) {
        event.preventDefault();
        setActive(instance.links, link);
        scrollToHeading(heading);

        if (isCompact()) closeDrawer(instance);

        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + id);
        }
      });
    });

    trigger.addEventListener('click', function () {
      if (panel.classList.contains('is-open')) {
        closeDrawer(instance);
      } else {
        openDrawer(instance);
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeDrawer(instance);
      });
    }

    instances.add(instance);
    root.dataset.tocReady = 'true';
    root.hidden = false;
    placeDesktop(instance);
    updateActive(instance);
  }

  function initAll(scope) {
    prune();
    const context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-article-toc]').forEach(initRoot);

    if (scope && scope.matches && scope.matches('[data-article-toc]')) {
      initRoot(scope);
    }
  }

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;

    window.requestAnimationFrame(function () {
      prune();
      instances.forEach(function (instance) {
        placeDesktop(instance);
        updateActive(instance);
      });
      scrollTicking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  if (COMPACT_QUERY.addEventListener) {
    COMPACT_QUERY.addEventListener('change', function () {
      instances.forEach(function (instance) {
        closeDrawer(instance);
        placeDesktop(instance);
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    instances.forEach(function (instance) {
      if (instance.panel.classList.contains('is-open')) closeDrawer(instance);
    });
  });

  document.addEventListener('click', function (event) {
    instances.forEach(function (instance) {
      if (!isCompact() || !instance.panel.classList.contains('is-open')) return;
      if (instance.root.contains(event.target)) return;
      closeDrawer(instance);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    prune();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
